import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import app from './modules/app'
import article from './modules/article'
import category from './modules/category'
import tag from './modules/tag'
import theme from './modules/theme'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user,
    app,
    article,
    category,
    tag,
    theme
  }
})
